import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1756254948675'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='4622'
        width='200'
        height='200'
    >
        <path
            d='M360.58 457.03c-1.78-0.79-3.86-0.4-5.24 0.98L98 715.35v61.96l302.63-302.58-40.05-17.7zM125.89 539.98L98 567.87v62.02l128.64-128.64zM459.91 500.87L101.73 859.11h61.91l339.28-339.23zM562.2 546.07L249.1 859.11h62.02L605.2 565.02zM706.34 549.35L396.58 859.11h62.02l347.44-347.45zM605.97 859.11L928 537.14v-62.02L544.06 859.11zM753.45 859.11L928 684.56V622.6L691.49 859.11zM900.93 859.11L928 832.04v-62.01l-89.08 89.08z'
            fill='currentColor'
            p-id='4623'
        ></path>
        <path
            d='M659.33 274.5a54.803 54.803 0 0 1-41.51-1.12L387.79 171.83a82.192 82.192 0 0 0-62.69-1.52L98 257.68v205.39l232.61-89.46a54.79 54.79 0 0 1 41.78 1.01l229.58 101.32a82.144 82.144 0 0 0 62.25 1.68L928 377.88V172.87L659.33 274.5z'
            fill='currentColor'
            p-id='4624'
        ></path>
    </svg>
)

export const NearSurfaceInspectionIcon = props => <Icon component={SVG} {...props} />
